// Custom GTM dataLayer events: nav_interaction, select_promotion, scroll_depth,
// login/sign_up handshake, and Nosto filter_applied/sort_applied.
(function () {
  'use strict';

  function pushDL(event, data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: event }, data || {}));
  }

  function text(el) {
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  window.pushDL = pushDL;

  document.addEventListener(
    'click',
    function (e) {
      var target = e.target;
      if (!target || !target.closest) return;

      var signupSrc = target.closest('[data-dl-signup-source]');
      if (signupSrc) {
        try {
          sessionStorage.setItem(
            'dl_signup_ctx',
            JSON.stringify({
              creative_name: signupSrc.getAttribute('data-creative-name') || '',
              creative_slot: signupSrc.getAttribute('data-creative-slot') || '',
              element_name: signupSrc.getAttribute('data-element-name') || text(signupSrc)
            })
          );
        } catch (err) {}
      }

      var link = target.closest('a[href]');
      if (!link) return;

      var promo = link.closest('[data-dl-promotion]');
      if (promo) {
        pushDL('select_promotion', {
          creative_slot: promo.getAttribute('data-creative-slot') || '',
          element_name: promo.getAttribute('data-element-name') || text(link),
          page_location: window.location.href
        });
        return;
      }

      if (link.closest('.header__inline-menu, .menu-parent, [data-dl-nav]')) {
        pushDL('nav_interaction', {
          nav_menu_name: text(link),
          nav_menu_link: link.getAttribute('href')
        });
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      var typeInput = form.querySelector('input[name="form_type"]');
      var formType = typeInput ? typeInput.value : '';

      try {
        if (formType === 'customer_login') {
          sessionStorage.setItem('dl_login_pending', '1');
        } else if (formType === 'create_customer') {
          var ctx = sessionStorage.getItem('dl_signup_ctx') || '';
          sessionStorage.setItem('dl_signup_pending', ctx || '1');
          sessionStorage.removeItem('dl_signup_ctx');
        }
      } catch (err) {}
    },
    true
  );

  var thresholds = [25, 50, 75, 100];
  var fired = {};
  var scrollTimer = null;

  function checkScrollDepth() {
    var doc = document.documentElement;
    var body = document.body || {};
    var scrollTop = window.pageYOffset || doc.scrollTop || body.scrollTop || 0;
    var scrollHeight = Math.max(doc.scrollHeight || 0, body.scrollHeight || 0);
    var viewport = window.innerHeight || doc.clientHeight || 0;
    var scrollable = scrollHeight - viewport;
    if (scrollable <= 0) return;

    var percent = Math.min(100, Math.round((scrollTop / scrollable) * 100));
    for (var i = 0; i < thresholds.length; i++) {
      var t = thresholds[i];
      if (percent >= t && !fired[t]) {
        fired[t] = true;
        pushDL('scroll_depth', { percent_scrolled: t, page_location: window.location.href });
      }
    }
  }

  window.addEventListener(
    'scroll',
    function () {
      if (scrollTimer) return;
      scrollTimer = setTimeout(function () {
        scrollTimer = null;
        checkScrollDepth();
      }, 200);
    },
    { passive: true }
  );

  // filter_applied / sort_applied delegated onto Nosto's SERP markup.
  document.addEventListener(
    'change',
    function (e) {
      var el = e.target;
      if (!el || !el.matches) return;

      if (el.matches('select.ns-selection-dropdown-menu')) {
        var opt = el.options ? el.options[el.selectedIndex] : null;
        pushDL('sort_applied', {
          sort_used: opt ? text(opt) : el.value || '',
          page_location: window.location.pathname
        });
        return;
      }

      if (el.matches('.ns-checkbox input[type="checkbox"]') && el.checked) {
        var label = el.closest('.ns-checkbox');
        var valueText = label ? text(label) : '';
        var facetEl = el.closest('.ns-sidebar-dropdown');
        var facetName = '';
        if (facetEl) {
          var nameEl = facetEl.querySelector('[data-nosto-element="facet"] span');
          if (nameEl) facetName = text(nameEl);
        }
        var filterUsed = facetName ? (valueText ? facetName + ': ' + valueText : facetName) : valueText;
        if (filterUsed) {
          pushDL('filter_applied', { filter_used: filterUsed, page_location: window.location.pathname });
        }
      }
    },
    true
  );
})();
